import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.scss';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import { store, history } from "./services/StoreService";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App {...{ store, history }} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
